import template from './users.create.html';
import controller from './users.create.controller';
import './users.create.scss';

let userscreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default userscreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/users/create/users.create.component.js